import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { targetAccumulatorApi } from '@/store/targetAccumulator/api/index.ts';

export type CancelTargetAccumulatorBody = {
  rfsId: string;
  tileId: string;
  /**
   * Normally, when we cancel the RFS, we keep the last quote received to display the expired quote.
   * If this is, true, we discard the quote and go back to the initial state (CANCELLED)
   */
  removeQuote?: boolean;
};

export const cancelTargetAccumulatorRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<unknown, CancelTargetAccumulatorBody>({
    query: (body) => {
      return {
        url: '/fxAccumulator/rfs/cancel',
        method: 'POST',
        body: {
          rfsId: body.rfsId,
        },
      };
    },
    onQueryStarted({ rfsId }, { dispatch }): Promise<void> | void {
      dispatch(targetAccumulatorApi.internalActions.removeMutationResult({ fixedCacheKey: rfsId }));
    },
  });
};
